@if (isDisabled) {
  <div class="disable-overlay" data-cy="single-material-status-disabled"></div>
}

<div class="flex-wrapper">
  <div class="header">
    <div [attr.data-cy]="'material-single-status-name-' + specialOrderMaterialGroupStatus.status.code"
    class="name">{{specialOrderMaterialGroupStatus.status.description}}</div>
    @if (isRetryEnabled()) {
      <app-tooltip
        [dynamic]="false"
        message="Retry">
        <div (click)="onRetryClick()"
          class="retry">
          <span class="icon iwp-icon-gen_repeat"></span>
          <span [attr.data-cy]="'material-status-retry-' + specialOrderMaterialGroupStatus.status.code"
          class="text">Retry</span>
        </div>
      </app-tooltip>
    }
  </div>

  <div [attr.data-cy]="'material-single-status-' + specialOrderMaterialGroupStatus.status.code"
    class="progress-bar">
    <div [attr.data-cy]="'material-status-bar-color-' + specialOrderMaterialGroupStatus.status.code"
      [ngClass]="'status ' + specialOrderMaterialGroupStatus.status.code"
      [ngStyle]="{'width': getMaterialInStatusPercentage(specialOrderMaterialGroupStatus.numberOfMaterials, totalOfMaterials) + '%'}"
    class="progress"></div>
  </div>

  <div class="amount">
    <span [attr.data-cy]="'material-status-number-' + specialOrderMaterialGroupStatus.status.code">{{specialOrderMaterialGroupStatus.numberOfMaterials}}</span>
    items
  </div>
</div>
